import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NotfoundComponent } from '../modules/screens/notfound/notfound.component';
import { UpserrorComponent } from '../modules/screens/upserror/upserror.component';
import { UpserrorcontentComponent } from '../modules/screens/upserrorcontent/upserrorcontent.component';
import { ScreensModule } from '../modules/screens/screens.module';


const routes: Routes = [
  {
    path: 'resultados/destino',
    loadChildren: '../modules/search/search.module#SearchModule'
  },
  {
    path: '',
    loadChildren: '../modules/payment/payment.module#PaymentModule'
  },
  {
    path: '404',
    component: NotfoundComponent
  },
  {
    path: 'ups-error',
    component: UpserrorComponent
  },
  {
    path: 'ups-error-content',
    component: UpserrorcontentComponent
  },
  {
    path: '**',
    redirectTo: '404'
  }

];

@NgModule({
  imports: [RouterModule.forChild(routes), ScreensModule],
  exports: [RouterModule]
})
export class CoreRoutingModule { }
